//* Libraries imports
import { Suspense } from "react";
import { motion } from "framer-motion";

//* Styles imports
import "./_components/enrollment-view.scss";

//* Components imports
import { Content } from "./_components/index";
import { WithPermissionCheck } from "../../../components/common/WithPermissionCheck";

export default function EnrollmentView() {
  return (
    <WithPermissionCheck>
      <motion.div
        className="row"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Suspense
          fallback={
            <motion.div
              className="d-flex justify-content-center align-items-center py-5"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </motion.div>
          }
        >
          <Content />
        </Suspense>
      </motion.div>
    </WithPermissionCheck>
  );
}
